{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "Adgangskode",
      "PLACEHOLDER": "Adgangskode",
      "ERROR": "Adgangskoden er for kort."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "Bekræft Adgangskode",
      "ERROR": "Adgangskoder stemmer ikke overens."
    },
    "API": {
      "SUCCESS_MESSAGE": "Adgangskoden blev ændret.",
      "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere"
    },
    "CAPTCHA": {
      "ERROR": "Bekræftelse er udløbet. Løs captcha igen."
    },
    "SUBMIT": "Send"
  }
}
